import { PlatformMembershipWithTeam } from 'shared/base';

export function setCustomHandlerLoginStatus(status: boolean) {
  if (status) {
    localStorage.setItem('__mock-session', 'true');
  } else {
    localStorage.removeItem('__mock-session');
  }
}

export function getCustomHandlerLoginStatus() {
  return localStorage.getItem('__mock-session') !== null;
}

export function setCustomHandlerMembership(membership: PlatformMembershipWithTeam | null) {
  if (membership) {
    localStorage.setItem('__mock-membership', JSON.stringify(membership));
  } else {
    localStorage.removeItem('__mock-membership');
  }
}

export function getCustomHandlerMembership() {
  const membership = localStorage.getItem('__mock-membership');

  return membership ? (JSON.parse(membership) as any) : null;
}

export function setCustomHandlerRegisterPlatformStatus(status: boolean) {
  if (status) {
    localStorage.setItem('__mock-platform', 'true');
  } else {
    localStorage.removeItem('__mock-platform');
  }
}

export function getCustomHandlerRegisterPlatformStatus() {
  try {
    const registerPlatformStatus = localStorage.getItem('__mock-platform');

    if (registerPlatformStatus === null) {
      return false;
    }

    return JSON.parse(registerPlatformStatus);
  } catch {
    return false;
  }
}
